<template>
    <div class="jwb">
        <div class="free-busy">
            <div class="bf-table" ref="bf_table_jwb">
                <div class="bf-body">
                    <div class="header" v-for="hour in hourHeader" :key="hour">
                        {{ hour }}
                    </div>
                </div>
                <div class="bf-body">
                    <div class="cell" v-for="(state,key) in states " :key="key"
                         :class="{'free':state==='空','busy':state!=='空','occupy':occupy(key)}"
                         @click="selectDate(key,state)">
                        {{ newState(state, key) }}
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "meeting-freebusy-jwb",
    data() {
        return {
            states: {},
            headers: [],
            start_date: this.date,
            group_id: 0,
            debounced: null,
        }
    },
    props: {
        date: {
            type: String,
            default() {
                return new Date().Format('yyyy-MM-dd');
            }
        },
        time: {
            type: String,
            default() {
                let d = new Date();
                d.setMinutes(Math.floor(d.getMinutes() / 30) * 30);
                return d.Format('hh:mm');
            }
        },
        duration: {
            type: Number,
            default() {
                return 30;
            }
        },
        id: {
            type: Number,
            default() {
                return 0;
            }
        },
        jump: {
            type: Boolean,
            default() {
                return true;
            }
        },
        group: {
            type: Number,
            default() {
                return 0;
            }
        }
    },
    watch: {
        date: {
            handler(val) {
                if (this.validateDate(val)) {
                    this.start_date = val;
                    this.queryBF();
                }
            },
            immediate: true,
        },
        time:{
            handler(val) {
                const hour = parseInt(val);
                if (this.$refs['bf_table_jwb']) {
                    this.$refs['bf_table_jwb'].scrollTo(74 * hour, 0);
                }
            }
        },
        duration: {
            handler() {
                this.queryBF();
            },
            immediate: true,
        },
        h323: {
            handler(val) {
                this.option_h323 = val;
                this.queryBF();
            },
            immediate: true,
        },
        group: {
            handler(val) {
                this.group_id = val;
                this.queryBF();
            },
            immediate: true,
        },

    },
    computed: {
        ...mapState(['process']),
        chineseDate() {
            const d = this.start_date.split('-');
            return d[1] + '月' + d[2] + '日';
        },
        hourHeader() {
            return this.headers.filter((h, i) => {
                return (i % 2 === 0)
            });
        },
    },
    methods: {
        validateDate(v) {
            const reg = /^\d{4}-\d{2}-\d{2}$/ig;
            return (reg.test(v));
        },
        newState(val, key) {
            if (val === '空') return '可用';
            if (this.occupy(key)) return '冲突';
            return '';
        },
        decrease() {
            let start = new Date(this.start_date.replace(/-/g, '/'));
            start.setDate(start.getDate() - 1);
            this.start_date = start.Format('yyyy-MM-dd');
            this.queryBF();
        },
        increase() {
            let start = new Date(this.start_date.replace(/-/g, '/'));
            start.setDate(start.getDate() + 1);
            this.start_date = start.Format('yyyy-MM-dd');
            this.queryBF();
        },
        queryBF() {
            if (this.debounced) this.debounced();
        },
        selectDate(key, state) {
            if (!this.jump) return;
            const vm = this;
            if (state === '空') {
                const d = this.start_date.split('-');
                const chinese = d[0] + '年' + d[1] + '月' + d[2] + '日';
                this.$affirm('是否选择 ' + chinese + ' ' + key + ' 为会议起始时间?').then(function () {
                    let ret = {date: vm.start_date, time: key};
                    vm.$emit('change', ret);
                }).catch(() => {
                });
            }
        },
        occupy(time) {
            if (this.$organization.no_indicate) return false;
            let start = parseInt(this.time.substr(0, 2)) * 60 + parseInt(this.time.substr(-2));
            let end = start + this.duration;
            const minutes = parseInt(time.substr(0, 2)) * 60 + parseInt(time.substr(-2));
            //console.log('time',time,start,end,this.time,minutes)

            return minutes >= start && minutes < end;
        }
    },
    created() {
        const vm = this;
        if (!this.debounced) {
            this.debounced = this.$debounce(200, false, function () {
                if (vm.group_id === 0) return;
                vm.$api('Query.Busy', {
                    start_date: vm.start_date,
                    id: vm.id,
                    duration: vm.duration,
                    h323: false,
                    group_id: vm.group_id,
                }, false).then(res => {
                    if (res.data.success) {
                        vm.$set(vm, 'states', res.data.data.states);
                        vm.headers = res.data.data.headers;
                        vm.state_h323 = res.data.data.h323;
                        this.$nextTick(function () {
                            const hour = parseInt(vm.time);
                            if (vm.$refs['bf_table_jwb']) {
                                vm.$refs['bf_table_jwb'].scrollTo(74 * hour, 0);
                            }
                        });
                    }
                })
            })
        }
    },
    mounted() {
        const vm = this;
        vm.queryBF();
    }
}
</script>

<style lang="scss">

$cell-width: 74px;
$cell-height: 41px;
$header-height: 32px;

.jwb {
    .free-busy {
        width: 100%;
        overflow: hidden;
        position: relative;
        border: 1px solid #bbb;
        min-height: $cell-height + $header-height + 2px;

        .bf-table {
            width: auto;
            overflow-x: auto;
            overflow-y: hidden;

            .bf-body {
                display: flex;

                .header {
                    height: $header-height;
                    flex: 0 0 $cell-width;
                    float: left;
                    background-color: #f5f5f5;
                    color: #666;
                    text-align: center;
                    line-height: 32px;
                    font-weight: 400;
                    border-left: 1px solid #bbbbbb;
                    border-bottom: 1px solid #bbbbbb;
                    box-sizing: border-box;
                    font-size: 14px;
                }

                .cell {
                    height: $cell-height;
                    flex: 0 0 $cell-width/2;

                    line-height: $cell-height - 5px;
                    background-color: white;
                    color: #101010;
                    text-align: center;
                    box-sizing: border-box;
                    border-left: 1px solid #bbbbbb;
                    float: left;
                    border-bottom: 1px solid #bbb;
                    font-size: 14px;


                    &.busy {
                        color: #101010;
                        background-color: #dddddd;
                    }

                    &.free {
                        color: #666666;
                        background-color: white;
                        cursor: pointer;
                    }

                    &.free.occupy {
                        color: #5a921b;
                        cursor: pointer;
                        background-color: #f1ffe7;
                    }

                    &.busy.occupy {
                        color: #c8171e;
                        cursor: not-allowed;
                    }
                }
            }
        }
    }
}
</style>
